import { Component, ElementRef,  OnDestroy, OnInit,  ViewChild } from '@angular/core';
import { NgIf } from '@angular/common';
import { Subject, Subscription, timer} from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ActivatedRoute, RouterModule } from '@angular/router';

import { KnownSteps, Session } from '../shared/models/session.model';
import { StepState } from '../shared/models/step.model';
import { StepService } from '../shared/step.service';
import { MainPageModule } from './main-page.module';
import { FormNavigationControlsComponent } from './navigation/form-navigation-controls/form-navigation-controls.component';
import { DynamicPaymentContainerComponent } from './cart/dynamic-payment-container/dynamic-payment-container.component';
import { DirectSessionLogicService } from '../shared/direct-session-logic.service';
import { Plan } from '../shared/models/plan.model';
import { NavigationPositionBarComponent } from './navigation/navigation-position-bar/navigation-position-bar.component';
import { LayoutChangeService } from '../shared/layout-change.service';
import { MobilePositionBar } from './navigation/navigation-position-bar/mobile-position-bar/mobile-position-bar.component';

import { DirectApiService } from '../shared/directApi.service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import * as bootstrap from 'bootstrap';
import { environment } from '../../environments/environment';


@Component({
  selector: 'app-main-page-logic',
  template:`
    <div class="main-page-container">
      
      @if(!isMobileNavBar){
        <navigation-position-bar ></navigation-position-bar>
      }
      @if(isMobileNavBar){
        <div style="align-self: flex-start;">
          <mobile-position-bar ></mobile-position-bar>
        </div>
      }


      <div class="card p-4 body-container" [ngClass]=" {'m-4': !isMobileNavBar }">

        <div class="row">

          <div class="col-lg-8 col-md-6 col-sm-12">
            <div #routerForms>
              <router-outlet class="routerOutlet" ></router-outlet>
            </div>
            
            @if(!isMobile){
              <div #formNav>
                <app-form-navigation-controls ></app-form-navigation-controls>
              </div> 
            }
            @if(isMobile){
              <div #formNav>
                <div style="height: 20px;" ></div>
              </div> 
            }
          </div>

          <div class="col-lg-4 col-md-6 col-sm-12" >
            <div class="payments col" #payments>
              <app-dynamic-payment-container></app-dynamic-payment-container>
            </div>
            <img src={{underCartBranding}} alt="Experian Logo" class="experian-icon" #logo/>
            <!-- <img src="assets/Icons/EXP-data-provided-by.svg" alt="Experian Logo" class="experian-icon" #logo/> -->
          </div>

        </div>

      </div>

    </div>

    <div id="loading-spinner" class="modal fade" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content">

          <div class="modal-header">
              <h5 class="modal-title">{{loadingMsg}}</h5>
          </div>
          
          @if(displaySpinner){
            <div class="modal-body">
              <div class="alt-spinner">
                <mat-spinner diameter="170" class="mat-mdc-progress-spinner"></mat-spinner>
              </div>
            </div>
          }
        </div>
      </div>
    </div>


  `,
  styleUrls: ['./main-page-logic.component.scss'],
  standalone: true,
  imports: [ 
    MainPageModule, 
    FormNavigationControlsComponent,
    NavigationPositionBarComponent,
    MobilePositionBar,
    DynamicPaymentContainerComponent,
    RouterModule,
    NgIf,
    MatProgressSpinner
   ],
})

export class MainPageLogicComponent implements OnInit, OnDestroy{
  @ViewChild('formNav') formNav!: ElementRef;
  @ViewChild('payments') payments!: ElementRef;
  @ViewChild('routerForms') routerForms!: ElementRef;
  @ViewChild('logo') logo!: ElementRef;

  private layoutChangeSubscription!: Subscription;
  private unsubscriber = new Subject<void>();

  underCartBranding = "/assets/BLANK_ICON.png";
  
  constructor(
    public stepService: StepService,
    public directSessionLogic: DirectSessionLogicService,
    public route: ActivatedRoute,
    private layoutChangeService: LayoutChangeService,
    public responsive: BreakpointObserver,
    public directApiService: DirectApiService
  ) {

    // let placeholderTwo = this.directSessionLogic.stepsListSignalValue;
    // console.log("steps list on main page logic construct: ", placeholderTwo);

    // let placeholder = this.directSessionLogic.knownStepsListSignalValue;
    // console.log("known steps on main page init: ", placeholder);
  };
  

  isMobile: boolean = false;
  isMobileNavBar: boolean = false;
  
  spinnerModalBootstrap: any = {};   
  loadingMsg: string = '';
  displaySpinner: boolean = true;


  ngOnInit() {
    let fakeValue = this.directSessionLogic.agilityObjectsSignalValue; //trigger agility objects load

    this.spinnerModalBootstrap = new bootstrap.Modal("#loading-spinner",{
      keyboard: false,
      backdrop: true,
      focus: true
    });    

    this.underCartBranding = environment.CompanyInfo.BrandingUnderCart;

    
    this.responsive.observe([
      Breakpoints.XSmall , Breakpoints.Small
      ])
      .subscribe(result => {
        this.isMobile = false; 
        if (result.matches) this.isMobile = true;      
    });

    this.responsive.observe([
      Breakpoints.XSmall 
      ])
      .subscribe(result => {
        this.isMobileNavBar = false; 
        if (result.matches) this.isMobileNavBar = true;      
    });



    this.directApiService.getLoadingMsg().subscribe((msg: string) => {
      const trimmedMsg = msg.trim();
      if(trimmedMsg.length > 0){
        //show loading message from session
        this.loadingMsg = trimmedMsg;
        this.displaySpinner = this.loadingMsg.search("%&%") > -1 ? false : true;
        if(!this.displaySpinner){
          this.loadingMsg = this.loadingMsg.replace("%&%", "");
        }
        this.showSpinnerModal();
        console.log("SHOW SPINNER", trimmedMsg, this.loadingMsg);
      }
      else{
        setTimeout(() => {
          //hide loading message from session
          this.hideSpinnerModal();
          console.log("HIDE SPINNER", trimmedMsg);
        }, 400);
      }
    });

  }


  get selectedPlan(): Plan {
    return this.directSessionLogic.selectedPlanSignalValue;
  }
  get knownSteps(): KnownSteps[] {
    return this.directSessionLogic.knownStepsListSignal();
  }
  get stepsList(): StepState[] {
    return this.directSessionLogic.stepsListSignal();
  }



  ngOnDestroy(): void {
    this.layoutChangeSubscription.unsubscribe();
    this.unsubscriber.unsubscribe();
    if(this.spinnerModalBootstrap){
      this.spinnerModalBootstrap.dispose();
    }
  }

  ngAfterViewInit(): void {
    this.adjustNavHeight();
    this.layoutChangeSubscription = this.layoutChangeService.layoutChanged$.subscribe(() => {
      timer(10).subscribe(() => this.adjustNavHeight());
    });
  }

  adjustNavHeight(){
    let routerFormsHeight = this.routerForms.nativeElement.offsetHeight;
    let formNavHeight = this.formNav.nativeElement.offsetHeight

    let formSideHeight = routerFormsHeight ;
    let cartSideHeight = this.payments.nativeElement.offsetHeight + this.logo.nativeElement.offsetHeight;

    if( (cartSideHeight > formSideHeight) && !this.isMobile){
      let adjustedHeight = (cartSideHeight) - (routerFormsHeight - formNavHeight) ;

      this.formNav.nativeElement.style.marginTop = `${adjustedHeight}px`;
    } else {
      this.formNav.nativeElement.style.marginTop = `10px`;
    }
  }

  showSpinnerModal(){
    this.spinnerModalBootstrap.show();
  }
  hideSpinnerModal(){
    this.spinnerModalBootstrap.hide();
  }
  
}
